import { render, staticRenderFns } from "./member_benefits.vue?vue&type=template&id=34ea0e08&scoped=true"
import script from "./member_benefits.vue?vue&type=script&lang=js"
export * from "./member_benefits.vue?vue&type=script&lang=js"
import style0 from "./member_benefits.vue?vue&type=style&index=0&id=34ea0e08&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ea0e08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ea0e08')) {
      api.createRecord('34ea0e08', component.options)
    } else {
      api.reload('34ea0e08', component.options)
    }
    module.hot.accept("./member_benefits.vue?vue&type=template&id=34ea0e08&scoped=true", function () {
      api.rerender('34ea0e08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/member_benefits.vue"
export default component.exports